import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import { useSite } from '../../contexts';

import Card from '../cards/Card';
import MagazineIcon from '../icons/Magazine';

import styles from '../../../styles/partials/new-article.module.css';

interface NewArticleProps {
    className?: string | null;
}

function NewArticle({ className = null }: NewArticleProps) {
    const { newArticle } = useSite();
    const route = useUrlGenerator();
    const magazinePageUrl = useMemo(() => route('pages.show', { page: 'magazine' }), [route]);
    // if (newArticle === null) {
    //     return null;
    // }
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.cols}>
                <div className={styles.col}>
                    <div className={styles.contentContainer}>
                        <h2 className={styles.title}>
                            <FormattedMessage
                                defaultMessage="Consultez les derniers articles"
                                description="New article section title"
                            />
                        </h2>
                        <Link href={magazinePageUrl || '#'} className={styles.link}>
                            <MagazineIcon withStroke withoutEye className={styles.icon} />
                            <span className={styles.label}>
                                <FormattedMessage
                                    defaultMessage="Magazine"
                                    description="Magazine button label"
                                />{' '}
                                →
                            </span>
                        </Link>
                    </div>
                </div>
                {/* <div className={styles.col}>
                    <div className={styles.cardContainer}>
                        {newArticle !== null ? (
                            <>
                                <Card item={newArticle} small poster className={styles.card} />
                                <Card
                                    type="magazine"
                                    url={newArticle.url}
                                    image={newArticle.image}
                                    small
                                    poster
                                    className={styles.cardEmpty}
                                />
                            </>
                        ) : null}
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default NewArticle;
